import { render, staticRenderFns } from "./compareOgVsGb.vue?vue&type=template&id=3b108728&scoped=true"
import script from "./compareOgVsGb.vue?vue&type=script&lang=js"
export * from "./compareOgVsGb.vue?vue&type=script&lang=js"
import style0 from "./compareOgVsGb.vue?vue&type=style&index=0&id=3b108728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b108728",
  null
  
)

export default component.exports